import { render, staticRenderFns } from "./GopInfo.vue?vue&type=template&id=e144d572&scoped=true&"
import script from "./GopInfo.vue?vue&type=script&lang=js&"
export * from "./GopInfo.vue?vue&type=script&lang=js&"
import style0 from "./GopInfo.vue?vue&type=style&index=0&id=e144d572&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e144d572",
  null
  
)

export default component.exports